var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgD28SocialKakaostory = function SvgD28SocialKakaostory(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#EFEFF3",
    cx: 14,
    cy: 14,
    r: 14
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.855 7.197a1.12 1.12 0 0 1 1.119 1.12v11.735a1.12 1.12 0 0 1-1.12 1.12H8.12A1.12 1.12 0 0 1 7 20.051V8.316a1.12 1.12 0 0 1 1.12-1.119h11.735zM15.8 10.353h-3.705a.45.45 0 0 0-.45.448v3.675c0 .248.2.448.45.448h1.708c-.012.437-.194.913-.459 1.335-.297.475-.931 1.001-.937 1.005a.245.245 0 0 0-.087.18c-.001.059.03.104.063.152l1.192 1.336s.058.06.105.072c.054.013.115.015.158-.018 2.063-1.587 2.36-3.576 2.413-4.653v-3.532a.449.449 0 0 0-.45-.448z",
    fill: "#27262A"
  }))));
};
export default SvgD28SocialKakaostory;